var map = {
	"./bg_01.jpg": "PJy9",
	"./bg_02.jpg": "5l1U",
	"./bg_03.jpg": "GVo1",
	"./bg_04.jpg": "8faF",
	"./login_bg.jpg": "HSqJ",
	"./logo_bj_HZ.jpg": "v3XJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Jpyv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/themes ^\.\/.*\.jpg$
// module id = Jpyv
// module chunks = 29